import { Link } from "react-router-dom";
import TopImage from "../../../common/TopImage";
import { Images } from "../../../../../config/images";
import "./License.css";
import "../../Dashboard/Dashboard.css";
import BackButton from "../../../../common/BackButton";

/**
 * @typedef {"school" | "organization"} tenanttype
 */

/**
 * ManualPaymentInfo component - Contact info page for manual payment
 * @param {{ type?: tenanttype }} props
 */

export const ManualPaymentInfo = ({ type = "school" }) => {
  return (
    <>
      <div className="container-fluid p-0">
        <div className="pb-2">
          <BackButton />
        </div>
        <section>
          <div className="container-fluid">
            <TopImage imageSrc={Images.TopImage} text="PURCHASE LICENSES" />
          </div>
        </section>

        <div className="purchase-form-container mt-4">
          <div className="manual-payment-section">
            <h3 className="manual-payment-title">Manual Payment</h3>

            <p className="manual-payment-text">
              To complete your purchase, please contact the Yuva Quest Support
              Team.
            </p>

            <div className="contact-info">
              <div className="contact-item">
                <i className="bi bi-telephone-fill"></i>
                <span>Support Contact:</span>
                <a href="tel:+919876543210">+91 98765 43210</a>
              </div>

              <div className="contact-item">
                <i className="bi bi-envelope-fill"></i>
                <span>Email:</span>
                <a href="mailto:support@yuvaquest.com">support@yuvaquest.com</a>
              </div>
            </div>

            <p className="manual-payment-text">
              Our team will share the official bank details and guide you
              through the manual payment process.
            </p>

            <p className="manual-payment-text">
              Once payment is made, please share your receipt or screenshot for
              verification.
            </p>

            <Link
              to={
                type === "school"
                  ? "/school-admin/settings/invoices"
                  : "/organization/settings/invoices"
              }
              className="submit-btn mt-3"
              style={{ display: "inline-block", textDecoration: "none" }}
            >
              Pending Invoices
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManualPaymentInfo;
